export default __webpack_public_path__ + "static/Nyhavn_Copenhagen_Denmark-ec12f17cf4be9c450a26610e0d105da3.jpg";